import { useState, yse } from "react";
import "./RangeBarSVG.css";
const RangeBarSVG = ({ low, high, ltp, variant, type, price }) => {
  if (!Number.isFinite(low) || !Number.isFinite(high) || !Number.isFinite(ltp))
    return null;

  const minVal = Math.min(low, ltp);
  const maxVal = Math.max(high, ltp);
  const padding = (maxVal - minVal) * 0.15 || 1;

  const axisMin = minVal - padding;
  const axisMax = maxVal + padding;

  const WIDTH = 700;
  const HEIGHT = variant === "mobile" ? 50 : 100;

  /* ---------------- VERTICAL LAYOUT (KEY PART) ---------------- */
  const BAR_Y = variant === "mobile" ? 60 : 50;

  const TOP_VALUE_Y = 18;

  // 🔽 Space BELOW bar (L / H)
  const LABEL_Y = BAR_Y + (variant === "mobile" ? 24 : 24);

  // 🔽 EXTRA space between | and LTP
  const LTP_TEXT_GAP = variant === "mobile" ? 52 : 34;

  const FONT =
    variant === "mobile"
      ? { value: 38, label: 20, ltp: 38 }
      : { value: 26, label: 20, ltp: 26 };

  /* ---------------- POSITION CALC ---------------- */
  const x = (v) => ((v - axisMin) / (axisMax - axisMin)) * WIDTH;

  const xLow = x(low);
  const xHigh = x(high);
  const xLtp = x(ltp);
  console.log("Variant received is:-", variant);
  //  useEffect(() => {
  //     const updateVariant = () => {
  //       setVariant(window.innerWidth < 768 ? "mobile" : "desktop");
  //     };

  //     updateVariant(); // 👈 run once on mount
  //     window.addEventListener("resize", updateVariant);

  //     return () => window.removeEventListener("resize", updateVariant);
  //   }, []);
  return (
    <svg
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      width="100%"
      height={HEIGHT}
      preserveAspectRatio="xMidYMin meet"
      style={{
        display: "block",
        overflow: "visible",
      }}
    >
      {/* ---------------- GRADIENT ---------------- */}
      <defs>
        <linearGradient
          id="rangeGradient"
          gradientUnits="userSpaceOnUse"
          x1="0"
          y1="0"
          x2={WIDTH}
          y2="0"
        >
          <stop offset="0%" stopColor="#ef4444" />
          <stop offset="50%" stopColor="#facc15" />
          <stop offset="100%" stopColor="#22c55e" />
        </linearGradient>
      </defs>
      {/* ---------------- RANGE BAR ---------------- */}
      <line
        x1={Math.min(xLow, xHigh, xLtp)}
        y1={BAR_Y}
        x2={Math.max(xLow, xHigh, xLtp)}
        y2={BAR_Y}
        stroke="url(#rangeGradient)"
        strokeWidth="4"
        strokeLinecap="round"
      />
      {/* ---------------- LOW / HIGH VALUES (TOP) ---------------- */}
      <text
        x={xLow}
        y={TOP_VALUE_Y}
        textAnchor="middle"
        fontSize={FONT.value}
        fontWeight="700"
      >
        {low}
      </text>
      <text
        x={xHigh}
        y={TOP_VALUE_Y}
        textAnchor="middle"
        fontSize={FONT.value}
        fontWeight="700"
      >
        {high}
      </text>
      {/* ---------------- L / H LABELS (MORE SPACE BELOW BAR) ---------------- */}
      (
      <>
        <text
          x={xLow}
          y={LABEL_Y}
          textAnchor="middle"
          fontSize={FONT.label}
          fontWeight="700"
          fill="#ef4444"
        >
          L
        </text>

        <text
          x={xHigh}
          y={LABEL_Y}
          textAnchor="middle"
          fontSize={FONT.label}
          fontWeight="700"
          fill="#22c55e"
        >
          H
        </text>
      </>
      ){/* ---------------- LTP MARKER ---------------- */}
      {/* <line
        x1={xLtp}
        y1={BAR_Y - 16}
        x2={xLtp}
        y2={BAR_Y + 16}
        stroke="#2563eb"
        strokeWidth="4"
      /> */}
      <circle
        cx={xLtp}
        cy={BAR_Y}
        r={variant === "mobile" ? 8 : 6}
        fill={
          type === "target" ? (price < ltp ? "#249966" : "#f87171") : "#2563eb"
        }
        // fill="#2563eb"
        stroke="white"
        strokeWidth="2"
      />
      <text
        x={xLtp}
        y={BAR_Y + 16 + LTP_TEXT_GAP}
        textAnchor="middle"
        fontSize={FONT.ltp}
        fontWeight="700"
        fill={
          type === "target" ? (price < ltp ? "#249966" : "#f87171") : "#2563eb"
        }
        // fill="#2563eb"
      >
        {ltp}
      </text>
    </svg>
  );
};

export default RangeBarSVG;
